


























import { MultiCheckboxFilterItem } from '@/model/form/FormItem';
import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';
import FormCheckbox from '@/components/form/FormCheckbox.vue';

@Component({
    components: {
        FormCheckbox,
    },
})
export default class MultiCheckboxFilter extends Vue {
    @Prop(String) readonly id!: string;

    @Prop(String) readonly label!: string;

    @Prop(Array) options!: MultiCheckboxFilterItem[];

    @Model('change', { type: Array }) readonly selectedValues!: number[];

    @Emit('change')
    onChange(changedValues: number[]): number[] {
        return changedValues;
    }

    onSelectedChange(value: boolean, option: MultiCheckboxFilterItem): void {
        if (value && !this.selectedValues.includes(option.value)) {
            this.onChange([...this.selectedValues, option.value]);
        } else if (!value) {
            this.onChange(
                this.selectedValues.filter(
                    (selectedValue) => selectedValue !== option.value,
                ),
            );
        }
    }

    checkboxValue(value: number): boolean {
        return this.selectedValues?.includes(value);
    }
}
